import React from "react";
import { Card, Typography, Tooltip } from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import "./BookingLineupCards.css";

const SaveButtonCard = ({ onClick, disabled, loading }) => {
    return (
        <Tooltip title={disabled ? "No changes to save" : "Save and invite players"} placement="bottom">
            <div 
                className={`lineup-save-card ${disabled ? 'disabled' : ''}`} 
                onClick={disabled ? undefined : onClick}
            >
                <Card elevation={1} className="lineup-save-card-inner">
                    <div className="lineup-save-card-content">
                        <div className="lineup-save-card-icon">
                            <SendIcon />
                        </div>
                        <Typography variant="body2" className="lineup-save-card-text">
                            {loading ? "Saving..." : "Save & Invite Players"}
                        </Typography>
                    </div>
                </Card>
            </div>
        </Tooltip>
    );
};

export default SaveButtonCard;
